export default "__VITE_ASSET__JJEerEry__"